import React, { useState, useEffect, useRef } from 'react';
import { convertRemToPixels } from '../UI/Utils';
import classes from './Home.module.scss';
import halfCircle from '../../assets/imgs/Azar-01.svg';
import BackgroundTitle from '../UI/BackgroundTitle/BackgroundTitle';

const importAll = r => r.keys().map(r);
const dotrunImgs = importAll(require.context('../../assets/imgs/dotrun/', false, /\.(png|jpe?g|svg)$/));
const artHouseImgs = importAll(require.context('../../assets/imgs/art-house/', false, /\.(png|jpe?g|svg)$/));
const photographyImgs = importAll(require.context('../../assets/imgs/photography/', false, /\.(png|jpe?g|svg)$/));
const portfolioImgs = importAll(require.context('../../assets/imgs/portfolio/', false, /\.(png|jpe?g|svg)$/));
const pLightImgs = importAll(require.context('../../assets/imgs/p-light/', false, /\.(png|jpe?g|svg)$/));

const images = [
  {
    imgs: artHouseImgs
  },
  {
    imgs: portfolioImgs
  },
  {
    imgs: dotrunImgs
  },
  {
    imgs: photographyImgs
  },
  {
    imgs: pLightImgs
  }
];
const maxDotRotate = 33;
const dotRotateAddition = maxDotRotate / (images.length - 1);
const dots = images.map((_, i) => (i * dotRotateAddition) - (maxDotRotate / 2));
console.log('dots :>> ', dots);

const poses = [
  { x: -15, y: -8,  z: -1 },
  { x: 15, y: -8, z: -1 },
  { x: -12, y: 10, z: -8 },
  { x: 12, y: 10, z: -8 }
];
const imgPoses = poses.map(pos => Object.keys(pos).map(key => ({ [key]: convertRemToPixels(pos[key]) }) )
                                                  .reduce((prev, current) => ({ ...prev, ...current }), {}));

const Home = () => {
  const [render, setRender] = useState(false);
  const [activeImg, setActiveImg] = useState(null);
  const [cords, setCords] = useState({ x: 0, y: 0 });
  const containerRef = useRef();

  useEffect(() => {
    let pause = false;
    const mouseMoveHandler = e => {
      if (containerRef.current && !pause) {
        const rect = containerRef.current.getBoundingClientRect();

        const cordX = ((e.pageX - rect.left) - rect.width/2) / (rect.width/2);
        const cordY = ((e.pageY - rect.top) - rect.height/2) / (rect.height/2);
        setCords({
          x: cordX,
          y: cordY
        });
        pause = true;
        setTimeout(()=> pause = false, 100);
      }
    }
    const mouseLeaveHandler = ()=> {
      setCords({ x: 0, y: 0 });
    }
    const container = containerRef.current;
    if (container) {
      container.addEventListener('mousemove', mouseMoveHandler);
      container.addEventListener('mouseleave', mouseLeaveHandler);
    }
    // setActiveImg(0);
    setRender(true);

    return ()=> {
      container.removeEventListener('mousemove', mouseMoveHandler);
      container.removeEventListener('mouseleave', mouseLeaveHandler);
    } 
  }, []);

  useEffect(() => {
    let timeout;
    if (render)
      timeout = setTimeout(()=> 
        setActiveImg(prev => prev < images.length-1 && prev !== null ? prev + 1 : 0)
      , activeImg === null ? 1500 : 3000);
    return ()=> clearTimeout(timeout);
  }, [activeImg, render]);

  return (
    <div className={[classes.Home, render ? classes.Render : ''].join(' ')} ref={containerRef}>
      <BackgroundTitle>HELLO</BackgroundTitle>

      <div className={[classes.Container, 'container'].join(' ')}>

        <div className={classes.Changers}>

          <div className={classes.Left}>
            <img src={halfCircle} alt="I" className={classes.Svg} />

            {dots.map((dotR, i) => (
              <span key={i} className={classes.Dot} 
                style={{ transform: `translate(-100%, -50%) rotate(${dotR}deg)` }} 
                onClick={()=> setActiveImg(i)}
              >
                <span></span>
              </span>
            ))}
            <span className={[classes.Dot, classes.Active].join(' ')} 
              style={{ transform: `translate(-100%, -50%) rotate(${dots[activeImg === null ? 0 : activeImg]}deg)` }}
            >
              <span></span>
            </span>
          </div>

          <div className={classes.Right}>
            <img src={halfCircle} alt="I" className={classes.Svg} />
            {dots.map((dotR, i) => (
              <span key={i} className={classes.Dot} style={{
                transform: `translate(0%, -50%) rotate(${dotR * -1}deg)`
              }} onClick={()=> setActiveImg(dots.length - 1 - i)}>
                <span></span>
              </span>
            ))}
            <span className={[classes.Dot, classes.Active].join(' ')} style={{
                transform: `translate(0%, -50%) rotate(${dots[activeImg === null ? 0 : activeImg]}deg)`
            }}>
              <span></span>
            </span>
          </div>

        </div>

        <div className={classes.Images} style={{
          transform: `translate(-50%, -50%) rotateX(${-cords.y * 20}deg) rotateY(${cords.x * 20}deg)`
        }}>
          {images.map((image, i) => {
            return image.imgs.map((img, j) => {
              const classNames = [classes.ImageContainer];
              if (i === activeImg) classNames.push(classes.Active);
              /* const styles = {
                clipPath: 'polygon(0 0, 50% 0, 10% 10%, 0 50%)'
              };
              if (j % 2 === 0) styles.clipPath = 'polygon(50% 0, 100% 0, 100% 50%, 90% 10%)';
              if (i === activeImg) styles.clipPath = 'polygon(0 0, 100% 0, 100% 100%, 0 100%)' */

              return (
                <div key={j+'-'+i} className={classNames.join(' ')} style={{
                  "--x": imgPoses[j].x + 'px',
                  "--y": imgPoses[j].y + 'px',
                  "--z": imgPoses[j].z + 'px',
                  "--exX": j % 2 === 0 ? '101%' : '-101%',
                  "--delay": 200 * j + 'ms',
                  // ...styles
                }}>
                  <img src={img} alt="IMG" className={classes.Image} />
                </div>
              );
            })
          })}
        </div>

        <div className={classes.Contents} style={{
          transform: `translate(-50%, -50%) rotateX(${-cords.y * 20}deg) rotateY(${cords.x * 20}deg)`
        }}>

          <div className={classes.Hello}>
            <h4 className={classes.Text}>Hello</h4>
          </div>
          <div className={classes.Title}>
            <span className={classes.Span}>
              <p className={classes.Text}>I'm</p>
            </span> 
            <h1 className={classes.Text}>
              {'Azher Uddin'.split('').map((word, i) => {

                return (
                  <span key={i} style={{
                    margin: word === ' ' ? '0 10px' : '0',
                    transitionDelay: 100 * i + 'ms'
                  }}>{word}</span>
                );
              })}
            </h1>
          </div>
          <div className={classes.Subtitle}>
            <p className={classes.Text}>Front-End Web Developer</p>
          </div>

        </div>

      </div>
    </div>
  );
}

export default Home;